var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { VerticalResponsivityManager } from "survey-core";
import { ReactElementFactory, SurveyElementBase, Scroll } from "survey-react-ui";
import { SurveyCreatorToolboxTool } from "./ToolboxItem";
import { SearchComponent } from "../components/Search";
import { SurveyCreatorToolboxCategory } from "./ToolboxCategory";
var AdaptiveToolbox = /** @class */ (function (_super) {
    __extends(AdaptiveToolbox, _super);
    function AdaptiveToolbox(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    AdaptiveToolbox.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var container = this.rootRef.current;
        this.toolbox.setRootElement(container);
        if (!container)
            return;
        this.manager = new VerticalResponsivityManager(this.toolbox.containerElement, this.toolbox);
    };
    AdaptiveToolbox.prototype.componentWillUnmount = function () {
        this.manager && (this.manager.dispose());
        this.toolbox.setRootElement(undefined);
        _super.prototype.componentWillUnmount.call(this);
    };
    Object.defineProperty(AdaptiveToolbox.prototype, "creator", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveToolbox.prototype, "toolbox", {
        get: function () {
            return this.creator.toolbox;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveToolbox.prototype.getStateElement = function () {
        return this.toolbox;
    };
    AdaptiveToolbox.prototype.renderItems = function (items, isCompact) {
        var _this = this;
        if (isCompact === void 0) { isCompact = false; }
        return items.map(function (item, itemIndex) {
            return React.createElement(SurveyCreatorToolboxTool, { item: item, creator: _this.creator, parentModel: _this.toolbox, isCompact: isCompact, key: item.renderedId });
        });
    };
    AdaptiveToolbox.prototype.renderCategories = function () {
        var _this = this;
        return this.toolbox.categories.map(function (category, index) {
            return React.createElement(SurveyCreatorToolboxCategory, { category: category, toolbox: _this.toolbox, key: "category" + index });
        });
    };
    AdaptiveToolbox.prototype.renderSearch = function () {
        var searchButton = this.toolbox.isCompactRendered ?
            React.createElement(React.Fragment, null,
                React.createElement(SurveyCreatorToolboxTool, { item: this.toolbox.searchItem, creator: this.creator, parentModel: this.toolbox, isCompact: this.toolbox.isCompactRendered, key: "searchitem" })) :
            null;
        return (React.createElement("div", { className: "svc-toolbox__search-container" },
            searchButton,
            React.createElement(SearchComponent, { model: this.toolbox.searchManager }),
            React.createElement("div", { className: "svc-toolbox__category-separator svc-toolbox__category-separator--search" })));
    };
    AdaptiveToolbox.prototype.render = function () {
        var _this = this;
        if (!this.toolbox.hasActions)
            return null;
        var search = this.toolbox.showSearch ? this.renderSearch() : null;
        var placeholder = this.toolbox.showPlaceholder ? React.createElement("div", { className: "svc-toolbox__placeholder" }, this.toolbox.toolboxNoResultsFound) : null;
        return (React.createElement("div", { ref: this.rootRef, className: this.toolbox.classNames },
            React.createElement("div", { onBlur: function (e) { return _this.toolbox.focusOut(e); }, className: "svc-toolbox__panel" },
                search,
                placeholder,
                React.createElement(Scroll, null, (this.toolbox.showInSingleCategory) ?
                    (React.createElement("div", { className: "svc-toolbox__category" }, this.renderItems(this.toolbox.renderedActions, this.toolbox.isCompactRendered)))
                    : this.renderCategories()))));
    };
    return AdaptiveToolbox;
}(SurveyElementBase));
export { AdaptiveToolbox };
ReactElementFactory.Instance.registerElement("svc-toolbox", function (props) {
    return React.createElement(AdaptiveToolbox, props);
});
